module.exports = __webpack_public_path__ + "img/buddy_ears-01.94c6ef03.svg";